<template>
  <div class="content-block dx-card">
    <h2>Routes</h2>
  </div>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>

  <div class="content-block dx-card" id="dataDiv">
    <DxDataGrid
      class="dx-card wide-card"
      :data-source="routes"
      :key-expr="routeId"
      :hover-state-enabled="true"
      :selection="{ mode: 'single' }"
      :show-borders="true"
      :columns-auto-width="true"
      :column-min-width="50"
      :allow-column-resizing="true"
      :column-resizing-mode="columnResize"
      :allow-column-reordering="true"
      :filter-builder="filterBuilder"
      :filter-value="filterValue"
      :style="{ 'max-height': datagridHeight }"
      no-data-text="No data."
      @selection-changed="onSelectionChanged"
      @initialized="saveGridInstance"
    >
      <DxLoadPanel :enabled="true" />
      <DxColumnChooser :enabled="true" mode="select" />
      <DxFilterRow :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="standard" />
      <DxExport :enabled="true" />
      <DxColumnFixing :enabled="true" />
      <DxPager
        :show-info="true"
        :show-page-size-selector="true"
        :allowed-page-sizes="[20, 50, 100]"
        :show-navigation-buttons="true"
      />

      <DxToolbar>
        <DxItem location="before" template="addRecordTemplate" />
        <DxItem location="after" template="refreshRecordTemplate" />
        <DxItem location="after" template="removeFilterRecordTemplate" />
        <DxItem location="after" name="exportButton" />
        <DxItem location="after" name="columnChooserButton" />
      </DxToolbar>

      <template #addRecordTemplate>
        <DxButton icon="add" @click="newRec" />
      </template>
      <template #refreshRecordTemplate>
        <DxButton icon="refresh" @click="refreshData" />
      </template>
      <template #removeFilterRecordTemplate>
        <DxButton icon="filter" @click="removeFilter" />
      </template>

      <DxColumn data-field="routeName" caption="Route" />
      <DxColumn data-field="operators" caption="Operators" />
      <DxColumn data-field="areas" caption="Areas" />
      <DxColumn data-field="products" caption="Products" />
      <DxColumn data-field="numberOfSites" caption="Number of Sites" />
      <DxColumn
        data-field="createdAt"
        caption="Date Created"
        data-type="date"
        :format="{ type: 'datetime', displayFormat: 'MMM d, yyyy h:mm a' }"
        :customize-text="createdDateText"
      />
    </DxDataGrid>
  </div>

  <DxLoadPanel
    v-model:visible="loadingVisible"
    :message="Loading"
    :show-indicator="true"
    :show-pane="true"
    :shading="true"
    :hide-on-outside-click="false"
    :on-shown="onLoadPanelShown"
    :on-hidden="onLoadPanelHidden"
    shading-color="rgba(0,0,0,0.4)"
  />
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxColumnFixing,
  DxPager,
  DxItem,
  DxToolbar,
  DxExport,
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import { DxLoadPanel } from "devextreme-vue/load-panel";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxLoadPanel,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport,
    DxColumnFixing,
    DxPager,
  },
  created() {
    this.loadPageData();
  },
  mounted() {
    window.addEventListener("resize", this.setDimensions);
    this.setDimensions();
  },
  unmounted() {
    window.removeEventListener("resize", this.setDimensions);
  },
  data() {
    return {
      loading: true,
      columnResize: "widget",
      dataGridInstance: null,
      loadingVisible: false,
      isLoadPanelVisible: false,
      datagridHeight: "40vh",
      currentArea: null,
      routes: [],
    };
  },
  computed: {},
  methods: {
    onLoadPanelShown() {
      setTimeout(() => {
        this.loadingVisible = false;
      }, 10000);
    },
    onLoadPanelHidden() {},
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    setDimensions() {
      const h = document.documentElement.clientHeight;
      this.datagridHeight = h - 250 + "px";
    },
    newRec() {
      this.$router.push({ name: "route-details", params: { id: 0 } });
    },
    removeFilter() {
      this.dataGridInstance.clearFilter();
      this.dataGridInstance.clearSorting();
    },
    refreshData() {
      this.loadPageData();
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({
        name: "route-details",
        params: { id: selectedRowsData[0].routeId },
      });
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      this.loadingVisible = true;
      try {
        await this.$store.dispatch("routes/loadRoutes", {
          forceRefresh: refresh,
        });
        this.routes = this.$store.getters["routes/getRoutes"];
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
        this.loadingVisible = false;
      }
    },
    createdDateText(e) {
      if (!e.value) return "";
      const date = new Date(e.value);

      return date instanceof Date && !isNaN(date)
        ? date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : "";
    },
  },
};
</script>

<style scoped>
h2 {
  margin-left: 1em;
}
</style>
